// components/DiagnosisSection.js
import React from 'react';
import Recommendations from './Recommendations';
import Sequences from './Sequences';
import Services from './Services';
import './Doctors.css';

const DiagnosisSection = ({ filterT, patientCard, onRecomChange, onSeqChange, onServiceChange, onSeqInProgress }) => {
   console.log('onSeqInProgress prop:', onSeqInProgress);
  return (
    <>
    
      
      <div className="card-wrapper">
        <Sequences
          patientCard={patientCard}
          filterT={filterT}
          onDataChange={(data, updateReqd) => onSeqChange(null, data, 'Sequences', false)}
          onSeqInProgress={(notif) => onSeqInProgress(notif)}
        />
      </div>
      
      <div className="card-wrapper">
        <Recommendations
          patientCard={patientCard}
          filterT='all'
          onDataChange={(data) => onRecomChange(null, data, 'Recommendations', false)}
        />
      </div>

      <div className="card-wrapper">
        <Services
            patientCard={patientCard}
            filterT='all' //{filterT === 'all' ? 'all' : filterT}
            onDataChange={(data) => onServiceChange(null, data, 'Services', false)}            
            />
      </div>
  
    </>
  );
};

export default DiagnosisSection;
